export default "__VITE_ASSET__DpLwM4IO__"